import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=de55b030&"
import script from "./Bonuses.vue?vue&type=script&lang=js&"
export * from "./Bonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports